<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Charts</strong></h4>
      <a href="https://mdbootstrap.com/vue/advanced/charts/#usage-minimalist/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr class="mb-4" />
    <container class="mt-5">
      <h4>Minimalist charts</h4>
      <row>
        <column md="4">
          <div class="d-flex justify-content-center">
            <mini-chart :value="value" color="#4CAF50">
              {{value}}%
            </mini-chart>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <badge color="green">Sales <fa icon="arrow-circle-up"/></badge>
          </div>
        </column>
        <column md="4">
          <div class="d-flex justify-content-center">
            <mini-chart :value="value2" color="#F44336">
              {{value2}}%
            </mini-chart>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <badge color="red">ROI <fa icon="arrow-circle-down"/></badge>
          </div>
        </column>
        <column md="4">
          <div class="d-flex justify-content-center">
            <mini-chart :value="value3" color="#9E9E9E">
              {{value3}}%
            </mini-chart>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <badge color="grey">Conversion <fa icon="minus-square"/></badge>
          </div>
        </column>
      </row>
    </container>
  </container>
</template>

<script>
import { Container, Row, Column, MiniChart, Badge, Fa } from 'mdbvue';

export default {
  name: 'ChartPage',
  components: {
    Container,
    Row,
    Column,
    MiniChart,
    Badge,
    Fa
  },
  data() {
    return {
      value: 56,
      value2: 76,
      value3: 100
    };
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
